import { WifiOff } from 'lucide-react';

interface Props {
  status: 'connecting' | 'connected' | 'error' | 'disabled';
}

export function RealtimeStatusBanner({ status }: Props) {
  if (status === 'connected' || status === 'connecting') return null;

  return (
    <div className="flex items-center gap-2 px-4 py-2 bg-amber-500/10 border border-amber-500/30 rounded-lg text-sm text-amber-400">
      <WifiOff className="h-4 w-4 shrink-0" />
      <span>
        {status === 'error'
          ? 'Conexao em tempo real perdida. Atualizacoes podem estar atrasadas.'
          : 'Atualizacoes em tempo real desativadas.'}
      </span>
    </div>
  );
}
